/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesViewType } from './WebApiModelsEnumerationTypesViewType';
import {
    WebApiModelsEnumerationTypesViewTypeFromJSON,
    WebApiModelsEnumerationTypesViewTypeFromJSONTyped,
    WebApiModelsEnumerationTypesViewTypeToJSON,
} from './WebApiModelsEnumerationTypesViewType';
import type { WebApiViewDtoCreateViewColumnDto } from './WebApiViewDtoCreateViewColumnDto';
import {
    WebApiViewDtoCreateViewColumnDtoFromJSON,
    WebApiViewDtoCreateViewColumnDtoFromJSONTyped,
    WebApiViewDtoCreateViewColumnDtoToJSON,
} from './WebApiViewDtoCreateViewColumnDto';

/**
 * 
 * @export
 * @interface WebApiViewDtoCreateViewDto
 */
export interface WebApiViewDtoCreateViewDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiViewDtoCreateViewDto
     */
    name: string;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesViewType}
     * @memberof WebApiViewDtoCreateViewDto
     */
    viewType: WebApiModelsEnumerationTypesViewType;
    /**
     * 
     * @type {number}
     * @memberof WebApiViewDtoCreateViewDto
     */
    customListId?: number | null;
    /**
     * 
     * @type {Array<WebApiViewDtoCreateViewColumnDto>}
     * @memberof WebApiViewDtoCreateViewDto
     */
    viewColumns?: Array<WebApiViewDtoCreateViewColumnDto> | null;
}

/**
 * Check if a given object implements the WebApiViewDtoCreateViewDto interface.
 */
export function instanceOfWebApiViewDtoCreateViewDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "viewType" in value;

    return isInstance;
}

export function WebApiViewDtoCreateViewDtoFromJSON(json: any): WebApiViewDtoCreateViewDto {
    return WebApiViewDtoCreateViewDtoFromJSONTyped(json, false);
}

export function WebApiViewDtoCreateViewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiViewDtoCreateViewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'viewType': WebApiModelsEnumerationTypesViewTypeFromJSON(json['viewType']),
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'viewColumns': !exists(json, 'viewColumns') ? undefined : (json['viewColumns'] === null ? null : (json['viewColumns'] as Array<any>).map(WebApiViewDtoCreateViewColumnDtoFromJSON)),
    };
}

export function WebApiViewDtoCreateViewDtoToJSON(value?: WebApiViewDtoCreateViewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'viewType': WebApiModelsEnumerationTypesViewTypeToJSON(value.viewType),
        'customListId': value.customListId,
        'viewColumns': value.viewColumns === undefined ? undefined : (value.viewColumns === null ? null : (value.viewColumns as Array<any>).map(WebApiViewDtoCreateViewColumnDtoToJSON)),
    };
}

